import { writable } from 'svelte/store';
import { types } from '@commercebear/portal-api';
import useConnection from './useConnection';
import { unsubscriber } from '../store';

const completedStatuses = new Set([
  types.taskStatus.COMPLETED,
  types.taskStatus.FAILED,
  types.taskStatus.CANCELLED,
]);

export default function useSse(url, session) {
  const { addEventListener } = useConnection(url);

  function progress(id) {
    const { set, subscribe } = writable({ progress: 0, status: null, message: null });

    return {
      subscribe(callback) {
        const removeEventListener = addEventListener(id, ({ data }) => {
          const { progress: jobProgress, status, message } = JSON.parse(data);

          const isCompleted = completedStatuses.has(status);
          set({ progress: (isCompleted ? 100 : jobProgress), status, message });
          if (isCompleted) {
            removeEventListener(); // there will be no more progress events
          }
        }, session);
        return unsubscriber([subscribe(callback), removeEventListener]);
      },
    };
  }

  function result(id) {
    // TODO: should this promise be unsubscribable somehow?
    let removeEventListener;

    const promise = new Promise((resolve, reject) => {
      removeEventListener = addEventListener(id, ({ data }) => {
        const { status, result: jobResult, error } = JSON.parse(data);
        if (status === types.taskStatus.COMPLETED) {
          resolve(JSON.parse(jobResult));
        }
        if (status === types.taskStatus.FAILED) {
          reject(error);
        }
      }, session);
    });

    return promise.finally(removeEventListener);
  }

  function onStart(callback) {
    return addEventListener('start', ({ data }) => callback(JSON.parse(data)), session);
  }

  return { onStart, progress, result };
}
